declare module "@mui/material/styles" {
  interface TypeBackground {
    drawer?: string;
    menu?: string;
    dark?: string;
    dark_transparent?: string;
  }
  interface PaletteOptions {
    progress?: {
      progress?: string;
      remaining?: string;
      complete?: string;
    };
    testRow?: {
      default?: string;
      hover?: string;
      selected?: string;
      selectedHover?: string;
    };
    notificationRow?: {
      default?: string;
      hover?: string;
      selected?: string;
      selectedHover?: string;
    };
  }
  interface Palette {
    progress: {
      progress: string;
      remaining: string;
      complete: string;
    };
    testRow: {
      default: string;
      hover: string;
      selected: string;
      selectedHover: string;
    };
    notificationRow: {
      default: string;
      hover: string;
      selected: string;
      selectedHover: string;
    };
  }
}

import { CssBaseline, responsiveFontSizes, ThemeProvider } from "@mui/material";
import { createTheme, ThemeOptions } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import environment from "../../util/environment";
import baseTheme from "./baseTheme";
import darkTheme from "./darkTheme";

const RunwayThemeProvider = (props: React.PropsWithChildren<unknown>) => {
  const ff_DarkMode = localStorage.getItem("runway.darkMode");
  const ff_CustomeTheme = localStorage.getItem("runway.theme");
  const defaultTheme = ff_DarkMode
    ? deepmerge(baseTheme, darkTheme)
    : baseTheme;
  return (
    <ThemeProvider theme={defaultTheme}>
      <ThemeProvider
        theme={(theme) => {
          let themeOverride: Partial<ThemeOptions> = theme;
          if (environment.theme) {
            themeOverride = deepmerge(themeOverride, environment.theme);
          }
          if (ff_CustomeTheme) {
            themeOverride = deepmerge(
              themeOverride,
              JSON.parse(ff_CustomeTheme),
            );
          }
          const combinedTheme = createTheme(theme, themeOverride, {
            components: {
              MuiDataGrid: {
                styleOverrides: {
                  cell: {
                    // override mui data grid cell after migrating from 6 to 7
                    // https://mui.com/x/migration/migration-data-grid-v6/#css-classes-and-styling
                    display: "flex",
                    alignItems: "center",
                  },
                },
              },
            },
          });
          return responsiveFontSizes(combinedTheme);
        }}
      >
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </ThemeProvider>
  );
};

export default RunwayThemeProvider;
